import { baidumap_children, bigScreen_baidumap_children, app_baidumap_children } from "./menus/index"
import { getOptDes } from "./menus/optDes"
const cxBaidumap = {
  name: "cxBaidumap",
  desc: "百度地图",
  render: () => import("./render/index.vue"),
  optDes: getOptDes,
  enable: false,
  menus: {
    app: [
      {
        name: "百度地图",
        group: "chart",
        children: app_baidumap_children,
        sort: 101,
        enable: false
      }
    ],
    bigScreen: [
      {
        name: "百度地图",
        children: bigScreen_baidumap_children,
        group: "chart",
        sort: 101,
        enable: false
      }
    ],
    portal: [
      {
        name: "百度地图",
        children: baidumap_children,
        group: "chart",
        sort: 101,
        enable: false
      }
    ]
  },
  toolbars: [
    {
      name: "cxBaidumap",
      label: "百度地图",
      comp: {
        baidumapComponentData: () => import("./toolbars/baidumap-options-data.vue"),
        baidumapComponentSetting: () => import("./toolbars/baidumap-options-setting.vue"),
        baidumapComponentStyle: () => import("./toolbars/baidumap-options-style.vue"),
      }
    }
  ]
}

export default cxBaidumap
